import { iots } from '@code-expert/prelude';
import { query } from '/imports/modules/Routing';

const reviewSectionKeys = {
  ready: null,
  done: null,
  ongoing: null,
};

export type ReviewSection = keyof typeof reviewSectionKeys;

export const reviewSectionQuery = query(
  iots.exact(iots.partial({ section: iots.keyof(reviewSectionKeys) })),
);
